import { useGLTF } from "@react-three/drei"
import { useKTX2 } from "../../../utils/useKtx"
import { useEffect, useMemo } from "react"
import * as THREE from 'three'


export default function Pipe(props) {
    const { nodes } = useGLTF('./models/02/pipe.glb')
    const base = useKTX2('./textures/01/sol-base.ktx2')
    // const texB = useMemo(() => base.clone(), [base])
    //  useEffect(() => {
    //     texB.wrapS = texB.wrapT = THREE.RepeatWrapping
    //     texB.repeat.set(1, 1)
    //     texB.needsUpdate = true
    //   }, [texB])
    return (
        <mesh
            {...props}
            geometry={nodes.Cylinder.geometry}
        >
            <meshStandardMaterial
                map={base}
                roughness={0.2}
                receiveShadows
                side={THREE.DoubleSide}
            />
        </mesh>
    )
}